
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"29","viewBox":"0 0 40 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.176 4.878a5.011 5.011 0 00-3.526-3.525C32.52.496 20 .496 20 .496s-12.52 0-15.65.824C2.668 1.781 1.284 3.165.823 4.878 0 8.008 0 14.5 0 14.5s0 6.524.824 9.621a5.012 5.012 0 003.525 3.526c3.163.857 15.651.857 15.651.857s12.52 0 15.65-.825a5.011 5.011 0 003.526-3.525c.824-3.13.824-9.62.824-9.62s.033-6.525-.824-9.655zM16.013 20.496V8.503l10.412 5.996-10.412 5.997z","fill":"#E2E8F0"}})])
          )
        }
      }
    